import React from 'react';
import {AccountLines} from './AccountLines.jsx';
import {Paper, Divider} from '@mui/material';
import PropTypes from 'prop-types';
import {ezprOrange} from '../../_helpers';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {getValueFromLabelValue} from '../../../utils/checkObjects';
import {formatMaterialName} from '../../../utils/helpers';
import {BrickContext} from 'olympe';

/**
 * @param {AccountTable.propTypes} props
 * @return {JSX.Element}
 */
export function AccountTable(props) {
    const useRequestStore = requestStores.get(props.prTag);

    const materials = useRequestStore((state) => state.materials);
    const material = materials.find((m) => m.id === props.materialId);

    if (material === undefined) {
        return (<div></div>);
    } else {
        return (
            <Paper className={'pr-editor-account-details-payment-box-container'}>
                <div style={{padding: '1vw'}}>
                    <div className={'pr-editor-account-details-payment-box-title'} style={{marginBottom: '1vh'}}>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.id + 1}</div>
                        <div className={'pr-editor-review-items-flex-big-element'}>{formatMaterialName(material.name)}</div>
                        <div className={'pr-editor-review-items-flex-big-element'}>{material.description}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.quantity}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{getValueFromLabelValue(material.unit)}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.price}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.currency.value}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.per}</div>
                        <div className={'pr-editor-review-items-flex-small-element'} style={{color: ezprOrange}}>{getValueFromLabelValue(material.unit)}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.tax}</div>
                        <div className={'pr-editor-review-items-flex-small-element'}>{material.totalPrice}</div>
                    </div>
                    <Divider sx={{
                        width: '98%',
                        color: 'rgb(198,198,198)',
                        borderColor: 'rgb(198,198,198)',
                        borderStyle: 'solid',
                        marginBottom: '1vh',
                    }} />
                    <AccountLines
                        prTag={props.prTag}
                        materialId={props.materialId}
                        context={props.context}
                        consumptionLevelCheckDetails={props.consumptionLevelCheckDetails}
                        consumptionLevelCheckStatus={props.consumptionLevelCheckStatus}
                        selectedAccounts={props.selectedAccounts}
                        onSelectAccount={props.onSelectAccount}
                        updateSelectedAccounts={props.updateSelectedAccounts}
                        onSelectAllAccounts={props.onSelectAllAccounts}
                        modifiedAllocation={props.modifiedAllocation}
                        handleCopyAllocation={props.handleCopyAllocation}
                        handleResetAllocation={props.handleResetAllocation}
                        resetAllocation={props.resetAllocation}
                    />
                </div>
            </Paper>
        );
    }
}

AccountTable.propTypes = {
    prTag: PropTypes.string,
    materialId: PropTypes.number,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    consumptionLevelCheckDetails: PropTypes.array,
    consumptionLevelCheckStatus: PropTypes.string,
    selectedAccounts: PropTypes.array,
    onSelectAccount: PropTypes.func,
    onSelectAllAccounts: PropTypes.func,
    updateSelectedAccounts: PropTypes.func,
    handleCopyAllocation: PropTypes.func,
    modifiedAllocation: PropTypes.object,
    handleResetAllocation: PropTypes.func,
    resetAllocation: PropTypes.object,
};
